import * as types from '../constants/ActionTypes';
import api from '../../config/api.js';
import store from '../store/store';

export function resetGalleryState(){
    return store.dispatch({
        type: types.RESET_GALLERY_STATE,
        payload: null,
    })
}

export const getGalleryItemsForPatient = (patientId) => {
    return (dispatch) => {
        if (api.defaults.headers.common['x-access-token']) {
            if (!patientId) return Promise.reject('No patient id')
            return api.get(`/gallery/patient/${patientId}/index`)
            .then((response) => {
                // console.log(response);
                dispatch({
                    type: types.SET_GALLERY_ITEMS_FOR_PATIENT,
                    payload: response.data
                });
                return Promise.resolve(response.data)
            })
            .catch((error) => {
                console.log('Error getting gallery items for patient', error);
                throw new Error(error);
            })
        } else {
            return Promise.reject()
        }
	}
}

export const getGalleryById = (galleryId) => {
    return (dispatch) => {
        if (api.defaults.headers.common['x-access-token']) {
            if (!galleryId) return Promise.reject('No gallery id')
            return api.get(`/gallery/${galleryId}`)
            .then((response) => {
                // console.log(response);
                dispatch({
                    type: types.SET_GALLERY_BY_ID,
                    payload: response.data
                })
            })
            .catch((error) => {
                console.log('Error getting gallery item', error);
                return Promise.reject(error);
            })
        } else {
            return false;
        }
	}
}

export const createGallery = (data) => {
    return (dispatch) => {
		if (!data) return Promise.reject('No data')
		return api.post(`/gallery/create`, data)
		.then((response) => {
            // console.log(response);
        })
        .catch((error) => {
            console.log('Error creating a new gallery item', error);
            return Promise.reject(error);
        })
	}
}

export const deleteGallery = (galleryId) => {
    return (dispatch) => {
        if (!galleryId) return Promise.reject('No gallery id')
		return api.delete(`/gallery/${galleryId}`)
		.then((response) => {
            // console.log(response);
        })
        .catch((error) => {
            console.log('Error deleting gallery item', error);
            return Promise.reject(error);
        })
	}
}
// Not being used
// export const createGalleryVideo = async (data, callback) => {
//     // return (dispatch) => {
//         if (!data) return Promise.reject('No form data')
//         return await api.post(`/gallery/video`, postData, {
//             headers: {
//                 "Content-Type": "multipart/form-data",
//             },
//             onUploadProgress: callback,
//         })
// 		.then((response) => {
//             console.log(response);
//             store.dispatch({
//                 type: types.SET_VIDEO_UPLOAD_PERCENTAGE,
//                 payload: 0
//             })
//         })
//         .catch((error) => {
//             console.log('Error creating a new video gallery item', error);
//             return Promise.reject(error);
//         })
// 	// }
// }

export const updateGalleryVideo = (galleryId, data) => {
    return (dispatch) => {
        if (!galleryId) return Promise.reject('No gallery id')
        if (!data) return Promise.reject('No form data')
		return api.put(`/gallery/${galleryId}/video`, postData)
		.then((response) => {
            // console.log(response);
        })
        .catch((error) => {
            console.log('Error updating a video gallery item', error);
            return Promise.reject(error);
        })
	}
}

export const deleteGalleryVideo = (galleryId) => {
    return (dispatch) => {
        if (!galleryId) return Promise.reject('No gallery id')
		return api.delete(`/gallery/${galleryId}/video`)
		.then((response) => {
            // console.log(response);
        })
        .catch((error) => {
            console.log('Error deleting video gallery item', error);
            return Promise.reject(error);
        })
	}
}


// WEBPACK FOOTER //
// ./src/actions/gallery.js